<template>
  <!--card标题-->
  <tk-flex
    between
    middle
    :style="{background: `linear-gradient(180deg, ${linearTopColor}, ${linearBottomColor})`}"
    class="full-width class-card-style p-b-8"
  >
    <tk-flex middle>
      <tk-flex middle class="class-card-title" :style="{fontSize: fontSize + 'px'}">
        <div class="font-bold">{{title}}</div>
        <div class="font-12 m-l-8 primary-gray" v-if="copyTitle">{{copyTitle}}</div>
      </tk-flex>
      <slot></slot>
    </tk-flex>
    <tk-flex
      middle
      class="caption"
      v-if="isMore"
      @click.native="toggleMore"
    >
      <div class="m-r-5">{{textMore}}</div>
      <tk-icon size="12">rightarrow</tk-icon>
    </tk-flex>
  </tk-flex>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    type: {
      type: String
    },
    commodityArr: {
      type: Array
    },
    isMore: {
      type: Boolean,
      default: true
    },
    linearTopColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0)'
    },
    linearBottomColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0)'
    },
    textMore: {
      type: String,
      default: '更多'
    },
    fontSize: {
      type: Number,
      default: 16
    },
    copyTitle: {
      type: String,
      default: ''
    }
  },
  methods: {
    /**
    * 切换更多
    * @date: 2020/3/27
    */
    toggleMore () {
      if (!this.type || !this.commodityArr.length) { return this.$tkGlobal.toast.add('没有更多数据') }
      // 限时抢购
      if (this.type === 'limitedTimeSnapping') { this.$push('/commodity/limitedTimeSnapping') }
      // 品牌专场
      if (this.type === 'brandSpecial') { this.$push('/commodity/brandSpecial') }
      // 品牌一
      if (this.type === 'oneBrandSpecial') {
        this.$push({ path: '/commodity/childSpecial', query: { classId: this.commodityArr[0].category } })
      }
      // 品牌二
      if (this.type === 'twoBrandSpecial') {
        this.$push({ path: '/commodity/childSpecial', query: { classId: this.commodityArr[0].category } })
      }
      // 品牌三
      if (this.type === 'threeBrandSpecial') {
        this.$push({ path: '/commodity/childSpecial', query: { classId: this.commodityArr[0].category } })
      }
      // 品牌四
      if (this.type === 'fourBrandSpecial') {
        this.$push({ path: '/commodity/childSpecial', query: { classId: this.commodityArr[0].category } })
      }
      // 新品上市
      if (this.type === 'newProducts') { this.$push('/commodity/newProductsMarket') }
      // 热卖榜单
      if (this.type === 'hotList') { this.$push('/commodity/hotList') }
      // 购买推荐详情
      if (this.type === 'buyRecommendation') { this.$push({ path: '/common/articlePage', query: { type: this.type } }) }
      // 促销礼品
      if (this.type === 'promotionalGifts') { this.$push('/commodity/promotionalGifts') }
      // 我的订单
      if (this.type === 'myOrder') { this.$push({ path: '/order/myOrderList', query: { tabIndex: '0', type: this.type } }) }
      // 客户订单
      if (this.type === 'clientOrder') { this.$push({ path: '/order/clientOrderList', query: { tabIndex: '0', type: this.type } }) }
    }
  }
}
</script>

<style lang="scss" scoped>
  /*背景色*/
  .class-card-style {
    line-height: 1;
  }
</style>
